import { HighchartsOptions } from '../../shared/component/pie-chart-simple/highcharts-common/highcharts-global-const';
import { LocalDate, LocalYearDate } from '../../../core/pojo/date-variable';

export class MaRaisedByIndustryChartDTO {
  totalRaisedYear1: MaPcntPieChart[] = [];
  totalRaisedYear2: MaPcntPieChart[] = [];
}

export class MaNumberOfDealsPerIndustryChartDTO {
  year1: MaPcntPieChart[] = [];
  year2: MaPcntPieChart[] = [];
}

export class MaTopFiveIndustriesChartDTO {
  capitalRaised: MaTopFiveIndChartsSeriesDTO;
  numberOfDeals: MaTopFiveIndChartsSeriesDTO;
}

export class MaTopFiveIndChartsSeriesDTO {
  periods: string[];
  industries: MaTopFiveIndChartSeriesDataDTO[];
}

export class MaTopFiveIndChartSeriesDataDTO {

  industryName: string;
  values: number[];
}

export class MaPcntPieChart {
  name: string; // industry
  y: number; // value by this industry
}

export class MarketAnalysisByVintageChartDTO {
  moicChartData = new VintageChartArraysMA();
  tvpiChartData = new VintageChartArraysMA();
  netIrrChartData = new VintageChartArraysMA();
  grossIrrChartData = new VintageChartArraysMA();
  contributionChartData = new MaContributionChartArrays();
}

export class VintageChartArraysMA {
  topArr: number[] = [];
  bottomArr: number[] = [];
  medianArr: number[] = [];
  selectedFundArr: number[] = [];
  periodsArr: string[] = [];
}

export class MaContributionChartArrays {
  averageContribution: number[] = [];
  restArr: number[] = [];
  periodsArr: string[] = [];
  selectedFundArr: number[] = [];
}

export class MaByIndustryChartsOptions {
  raisedByIndustry = new MaRaisedByIndustryChartsOptions();
  dilution: Partial<HighchartsOptions>;
  numberOfDeals: Partial<HighchartsOptions>;
  numberOfDealsPerIndustry = new MaNumOfDealsByIndustryChartsOptions();
  topFiveIndustries = new MaTopFiveIndustriesChartsOptions();
}

export class MaByVintageChartsOptions {
  dpi: Partial<HighchartsOptions>;
}

export class MaRaisedByIndustryChartsOptions {
  year1: Partial<HighchartsOptions>;
  year2: Partial<HighchartsOptions>;
}

export class MaNumOfDealsByIndustryChartsOptions {
  year1: Partial<HighchartsOptions>;
  year2: Partial<HighchartsOptions>;
}

export class MaTopFiveIndustriesChartsOptions {
  capitalRaised: Partial<HighchartsOptions>;
  numberOfDeals: Partial<HighchartsOptions>;
}

/**
 * Used in Raised by Industry charts titles.
 *
 * Example: this.selected.period = '2022-03-10'
 *          year1 = '2021-03-10'
 *          year2 = '2020-03-10'
 */
export class MaRaisedByIndustryPreviousYears {
  year1: LocalDate;
  year2: LocalDate;
}

export class MaByVintageDTO {
  charts: MarketAnalysisByVintageChartDTO;
  dpi: MaDpiByVintage;
}

export class MaDpiByVintage {
  table: MaDpiByVintageTable[];
  chart: MaDpiByVintageChart;
}

export class MaDpiByVintageTable {
  vintageYear: LocalYearDate;
  numberOfFunds: string;
  pcntOfFunds: number;
  medianDpi: number;
}

export class MaDpiByVintageChart {
  vintageYears: string[];
  numberOfFunds: number[];
  pcntOfFunds: number[];
  medianDpi: number[];
}

/**
 * Contains data for MA by Industry
 *  - Dilution
 *     - table
 *     - chart
 *  - Raised per industry
 *    - chart
 *  -Number of deals
 *    - chart
 *  -Top five industries
 *    - capital raised - chart
 *    - numberOfDeals - chart
 */
export class MaByIndustryDTO {
  dilution: MaDilution;
  raisedPerIndustry: MaRaisedByIndustryChartDTO;
  numberOfDeals: MaNumOfDealsChart;
  numberOfDealsPerIndustry: MaNumberOfDealsPerIndustryChartDTO;
  topFiveIndustries: MaTopFiveIndustriesChartDTO;
}

export class MaRaisedPerIndustryTableRow {
  year: LocalDate;
  raisedPerIndustry: number[];
}

/**
 * Used to fill the Number of deals chart in MA by Industry
 */
export class MaNumOfDealsChart {
  group1: number[]; // <25m
  group2: number[]; // <75m
  group3: number[]; // <150m
  group4: number[]; // >150m
  periods: string[];
}

/**
 * Used to fill the Dilution table and chart in MA by Industry
 */
export class MaDilution {
  table: MaDilutionTable[];
  chart: MaDilutionChart;
}

/**
 * Used to fill the Dilution table in MA by Industry
 */
export class MaDilutionTable {
  upToPost: string;
  dealsPcnt: number;
  avgRound: number;
  avgPost: number;
  dilution: number;
}

/**
 * Used to fill the Dilution chart in MA by Industry
 * Data stored in Highcharts format;
 */
export class MaDilutionChart {
  upToPost: string[];
  avgRound: number[];
  avgPre: number[]; // PreMoney = PostMoney - Round
  dilution: number[];
}

export const RAISED_BY_INDUSTRY_TITLE_FIRST_PART = '12 month ended ';

